import { Link } from "react-router-dom";
import { CheckCircle2, Circle, X, Sparkles, ArrowRight } from "lucide-react";

export const OnboardingCard = ({ data, onDismiss }) => {
  const steps = [
    { done: !!data?.assessment, label: "Asesmen", desc: "Temukan minat, bakat & kekuatan kognitifmu.", to: "/asesmen", cta: "Mulai Asesmen" },
    { done: !!data?.assessment, label: "Profilku", desc: "Lihat kesimpulan lengkap & tipe belajarmu.", to: "/profilku", cta: "Buka Profilku" },
    { done: !!data?.journey?.bidang_minat, label: "Jelajahi Bidang", desc: "Pahami bidang, mapel, prodi & kariernya.", to: "/jelajahi-bidang", cta: "Jelajahi Bidang" },
    { done: !!(data?.journey?.rencana?.length || data?.journey?.mapel_pilihan?.length), label: "Susun Langkah", desc: "Pilih mapel & susun rencana serta targetmu.", to: "/susun-langkah", cta: "Susun Langkah" },
    { done: (data?.tryout_count || 0) > 0, label: "TryOut", desc: "Latih & ukur pencapaianmu vs target.", to: "/tryout", cta: "Mulai TryOut" },
    { done: false, optional: true, label: "Info Jalur", desc: "Pelajari jalur SNBP/SNBT, Vokasi & Kedinasan.", to: "/info-jalur", cta: "Buka Info Jalur" },
  ];
  const doneCount = steps.filter((s) => s.done).length;

  return (
    <div className="clay-card p-7 mb-8 relative" data-testid="onboarding-card">
      <button onClick={onDismiss} data-testid="onboarding-dismiss" className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-[#1A1C1A]/5 text-[#5C5F5C]"><X className="h-4 w-4" /></button>
      <div className="flex items-center gap-2 mb-1"><Sparkles className="h-5 w-5 text-[#E25E3E]" /><h2 className="font-heading font-black text-xl text-[#1A1C1A]">Selamat datang di TalentaPath! 👋</h2></div>
      <p className="text-sm text-[#5C5F5C] mb-5">Ikuti langkah berikut agar perjalananmu maksimal. ({doneCount}/{steps.length} selesai)</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {steps.map((s, i) => (
          <div key={i} data-testid={`onboarding-step-${i}`} className={`rounded-xl border p-4 ${s.done ? "border-[#4A6B53]/40 bg-[#4A6B53]/5" : "border-[#E5E0D8]"}`}>
            <div className="flex items-start gap-2">
              {s.done ? <CheckCircle2 className="h-5 w-5 text-[#4A6B53] shrink-0" /> : <Circle className="h-5 w-5 text-[#C9C4BB] shrink-0" />}
              <div className="min-w-0">
                <p className="text-sm font-semibold text-[#1A1C1A]">{i + 1}. {s.label}{s.optional && <span className="text-[10px] text-[#5C5F5C] font-normal"> (opsional)</span>}</p>
                <p className="text-xs text-[#5C5F5C] mt-0.5">{s.desc}</p>
                {!s.done && s.to && <Link to={s.to} className="text-xs font-medium text-[#E25E3E] inline-flex items-center gap-1 mt-1.5">{s.cta} <ArrowRight className="h-3 w-3" /></Link>}
                {!s.done && !s.to && <span className="text-xs text-[#5C5F5C] inline-flex items-center gap-1 mt-1.5">{s.cta} ↓</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnboardingCard;
